import { AmlDetails, CommonLayout, CommonLayoutForPOA, Footer } from '../commonComponents';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  Box,
  Button,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  Dialog,
  Tooltip,
  Stepper,
  StepConnector,
  stepConnectorClasses,
  Step,
  StepButton,
  StepLabel,
  StepIconProps,
  StepIcon,
  Stack,
  Hidden,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Theme, styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplicationDetails,
  getDocuments,
  isFormValidForSubmission,
  nonIndividualFormValidForSubmission,
  sendIsDeclareTermsAndConditions,
  updateApplication,
} from '../../redux-store/actions/application';
import ContactDetails from './contactDetails';
import KycDetails from './kycDetails';
import FatcaDetails from './FatcaDetails';
import NomineeDetails from './nomineeDetails';
import InvestAndPaymentDetails from './InvestmentAndPayment';
import BankDetails from './BankDetails';
import DocumentDetails from './DocumentDetails';
import {
  ApplicationProps,
  DiyESignResponseBody,
  Document,
  nationaliyType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  REJECTED_ROLES,
  USER_ROLES,
  APPLICATION_STATUS,
  ApplicationStatusBasedOnRole,
  APPLICATION_TYPE,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_STATUS_AMCAPPROVER_individual,
  APPLICATION_LISTING_STATUS,
  PHYSICAL_DIGITAL_FLOW,
  ONBOARDING_DEMAT_DETAILS,
  NEXEDGE_INVESTMENT_PREFERENCE,
  BseClientActivationStatusMaster,
  leegalityText,
  applicantStatusMasters,
  ELOG_BSE,
} from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import * as yup from 'yup';
import { Form, Formik, FormikContextType, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import CloseIcon from '@mui/icons-material/Close';
import { MFTextField } from '../../lib/formik';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatShortDateAndTime } from '../../utils/date';
import {
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  sendApplication_Nri,
} from '../../utils/utilityFunctions';
import { NonIndividualApplicationLayout } from '../NonIndividualApplicationDetails';
import { setDiyInvestorOnboardingAuthData, showError } from '../../redux-store/actions/auth';
import { ConfirmationDialog } from '../commonComponents';
import DistributorDetails from './rmDetails';
import RelatedPersonDetails from './relatedPersonDetails';
import { diyESign, getNationalityList } from '../../redux-store/actions/userManagement';
import PersonalDetails from './personalDetails';
import RiskProfiles from './RiskProfiles';
import { riskProfileMasterData } from '../../redux-store/actions';
import { TermsAndConditionsCard } from './TermsAndConditions';
import ServicePreference from './servicePreferenceDetails';
import InvestmentPreference from './investmentPreferenceDetails';
import RMConcentForBSE from './rmConsentBse';
import Comments from './Comments';
import { EditIcon, StepperSuccessIcon, SuccessIcon } from '../../assets/SvgIcons';
import InvOnboardingLayout from '../InvestorOnboarding/InvOnboardingLayout';
import NexEdgeInvestmentPreference from './NexEdgeInvPref';
import DematDetails from './DematDetails';
import { DeclareTermsAndConditionsScheme } from '../../utils/schema';
import { storeApplicationId, storeInterfaceCode, storeInvestorClientId, storeIwappId } from '../../redux-store/actions/id';
import { setInvestorRmId } from '../../redux-store/actions/sessionData';
import DuplicatePanApplications from './DuplicatePanApplications';
import ServiceDetails from './ServiceDetails';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

const BootstrapStepConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    flexDirection: "column",
    height: 5,
    borderLeftWidth: "1px",
    borderLeftColor: `${theme.palette.text.secondary}26`,
    borderLeftStyle: "solid"
  },
}));

const NonIndividualMenuItemList = [
  'Distributor details',
  'Contributor Details',
  'Contact Details',
  'Investment & Payment Details',
  "Investor's Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Document Details',
  'Authorised Signatory',
  'Declaration of UBO',
  'FATCA',
  // 'Risk Profile',
];

const MenuItemList = [
  'RM Details',
  'Personal Details',
  // 'Details of Related Person',
  'Contact Details',
  'Additional KYC Details',
  'Nominee Details',
  'FATCA Declaration',
  'Bank Details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['DP Details'] : []),
  'Risk Profiles',
  // 'Investment Preference',
  // 'Service Preference',
  'Upload Documents',
];

const NonIndividualMenuItemListLink = [
  'distributor-details',
  'personal-details',
  'contact-details',
  'investment-payment-details',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['dp-details'] : []),
  'document-details',
  'authorised-signatory',
  'declaration-ubo',
  'fatca',
  // 'risk-profile',
];

const MenuItemListLink = [
  'rm-details',
  'personal-details',
  // 'related-person-details',
  'contact-details',
  'additional-KYC-details',
  'nominee-details',
  'fatca',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ["dp-details"] : []),
  'risk-profiles',
  // 'investment-preference',
  // 'service-preference',
  'document-details',
];

export function RejectedDetails({
  title,
  description,
}: {
  title: string | null;
  description: string | null;
}): JSX.Element {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontSize: 17, fontWeight: 500, color: 'text.secondary' }}>
          {title}:{' '}
          <Typography
            component="span"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              letterSpacing: '0.4px',
              fontWeight: 700,
              ml: { sm: 0.5 },
            }}>
            {description}
          </Typography>
        </Typography>
      </Grid>
    </>
  );
}

export function ApplicationDetailsCommonLayout({
  loading,
  application,
  values,
  setValues,
  leegalityUrlOpen = false,
  eLogUrlOpen = false,
  setDuplicatePanApplicationCount = () => { return; },
  setDuplicatePanCheckboxValue = () => { return; },
  duplicatePanCheckboxValue = false

}: {
  loading: boolean;
  application: ApplicationProps;
  values?: Partial<{ isDeclareTermsAndConditions: boolean }>;
  setValues?: React.Dispatch<React.SetStateAction<{ isDeclareTermsAndConditions: boolean }>>;
  leegalityUrlOpen?: boolean
  eLogUrlOpen?: boolean;
  setDuplicatePanApplicationCount?: Dispatch<SetStateAction<number>>;
  setDuplicatePanCheckboxValue?: Dispatch<SetStateAction<boolean>>;
  duplicatePanCheckboxValue?: boolean;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { path: currentPath } = useRouteMatch();
  const { onboardingVia = '', status = '', bseClientActivationStatus = '' } = application || {};

  const isDiyInvOnboardingApplicationDetails = currentPath.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = currentPath.includes('investor-onboarding-application-preview')

  return (
    <>
      {loading && <LinearProgress />}
      {application && (
        <>
          {/* <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {application.clientCode && (
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'text.secondary',
                      }}>
                      Client Code : {application.clientCode}
                    </Typography>
                  )}
                  <Typography
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: 'rgba(51, 127, 201, 0.7)',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: 'rgba(35, 133, 63, 0.7)',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                    }}>
                    Status:{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: '#B78813',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.OPE,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={() =>
                            application.signedLeegalityFile?.url &&
                            window.open(application.signedLeegalityFile?.url)
                          }>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box> */}
          {PHYSICAL_DIGITAL_FLOW && !isDiyInvOnboardingApplicationPreview && (<Typography
            variant='body_600'
            sx={(theme: Theme) => ({
              marginLeft: "35px",
              color: theme.palette.text.primary,
              mb: 1
            })}
          >
            {`Onboarding Type : ${onboardingVia?.toUpperCase()}`}
          </Typography>
          )}
          {isDiyInvOnboardingApplicationPreview && (
            <>
              {/* <Typography
                variant='body_600'
                sx={(theme: Theme) => ({
                  marginLeft: "35px",
                  color: theme.palette.text.primary,
                  mb: 1
                })}
              >
                {(() => {
                  if (leegalityUrlOpen) return `Onboarding Status : ${APPLICATION_LISTING_STATUS['sent_to_applicant1']}`
                  if (eLogUrlOpen) return `Onboarding Status : ${APPLICATION_LISTING_STATUS['completed']}`
                  return `Onboarding Status : ${APPLICATION_LISTING_STATUS[status] || '-'}`
                })()}
              </Typography> */}
              <Typography
                variant='body_600'
                sx={(theme: Theme) => ({
                  marginLeft: "35px",
                  color: theme.palette.text.primary,
                  mb: 1
                })}
              >
                {`BSE Status : ${BseClientActivationStatusMaster[(bseClientActivationStatus ?? "").toLowerCase()] ? BseClientActivationStatusMaster[(bseClientActivationStatus ?? "").toLowerCase()] : '-'}`}
              </Typography>
            </>
          )}
          {isDiyInvOnboardingApplicationDetails && (
            <>
              <Typography
                variant='body_600'
                sx={(theme: Theme) => ({
                  marginLeft: "35px",
                  color: theme.palette.text.primary,
                  mb: 1,

                })}
              >
                {`BSE Status : ${BseClientActivationStatusMaster[(bseClientActivationStatus ?? "").toLowerCase()] ? BseClientActivationStatusMaster[(bseClientActivationStatus ?? "").toLowerCase()] : '-'}`}
              </Typography>
            </>
          )}
          {/* {[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) && (
            <div id="rm-details">
              <RMConcentForBSE application={application} />
            </div>
          )} */}
          {USER_ROLES.INVESTOR !== role && (
            <AmlDetails
              applicants={application.applicants}
              applicationType={application.applicationType}
            />
          )}
          {(isDiyInvOnboardingApplicationPreview || isDiyInvOnboardingApplicationDetails || role !== USER_ROLES.INVESTOR) && application?.comments?.length > 0 && (
            <Comments application={application} />
          )}
          {(isDiyInvOnboardingApplicationPreview || isDiyInvOnboardingApplicationDetails) && (
            <ServiceDetails application={application} />
          )}
          <DistributorDetails application={application} isDiyInvestorOnboarding={isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview} />
          <div id='personal-details'>

            <PersonalDetails
              applicants={application.applicants}
              modeOfHolding={application.modeOfHolding}
              application={application}
            />
          </div>

          {/* <div id="related-person-details">
            <RelatedPersonDetails applicants={application.applicants} />
          </div> */}
          <div id='contact-details'>

            <ContactDetails applicants={application.applicants} />
          </div>

          <div id='additional-KYC-details'>

            <KycDetails applicants={application.applicants} />
          </div>

          <div id='nominee-details'>

            <NomineeDetails application={application} />
          </div>
          <div id='fatca'>
            <FatcaDetails applicants={application.applicants} />
          </div>
          <div id="bank-details">

            <BankDetails banks={application.banks} />
          </div>
          {ONBOARDING_DEMAT_DETAILS && (
            <div id="dp-details">
              <DematDetails demats={application.demats} />
            </div>
          )}
          <div id='risk-profiles'>

            <RiskProfiles application={application} />
          </div>
          {/* <div id='investment-preference'>
            {NEXEDGE_INVESTMENT_PREFERENCE ? <NexEdgeInvestmentPreference application={application} /> :
              <InvestmentPreference application={application} />}
          </div> */}
          {/* <div id='investment-preference'>
            <InvestmentPreference application={application} />
          </div> */}
          {!NEXEDGE_INVESTMENT_PREFERENCE ? (
            <div id='service-preference'>
              <ServicePreference application={application} />
            </div>
          ) : null}
          <div id='document-details'>
            <DocumentDetails application={application} />
          </div>
          {[USER_ROLES.AMCAPPROVER].includes(`${role ?? ""}`.toLowerCase() as USER_ROLES) && (
            <Box mt={5}>
              <DuplicatePanApplications
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}
              />
            </Box>
          )}

          {role !== USER_ROLES.AMCAPPROVER && (
            <TermsAndConditionsCard
              application={application}
              values={values ?? {}}
              setValues={setValues ?? (() => { '' })}
              leegalityUrlOpen={leegalityUrlOpen}
              eLogUrlOpen={eLogUrlOpen}
            />
          )}
        </>
      )}
    </>
  );
}

const RejectApproveButtons = ({
  handleOpen,
  handleDialogOpen,
  handleSendBack,
  approve,
  reject,
  sendBack,
  duplicatePanApplicationCount = 0,
  duplicatePanCheckboxValue = false
}: {
  handleOpen: () => void;
  handleDialogOpen: () => void;
  handleSendBack: () => void;
  approve: boolean;
  reject: boolean;
  sendBack: boolean;
  duplicatePanApplicationCount?: number;
  duplicatePanCheckboxValue?: boolean;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <Grid display="flex" justifyContent="center" alignItems="center">
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={reject}
        variant="outlined"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'primary.main',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          mr: 3,
        }}
        onClick={handleOpen}
        disabled={approve || sendBack}>
        Reject
      </LoadingButton>
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={approve}
        variant="contained"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
          mr: USER_ROLES.AMCAPPROVER === role ? 3 : 0,
        }}
        onClick={handleDialogOpen}
        disabled={reject || sendBack || (duplicatePanApplicationCount > 1 && !duplicatePanCheckboxValue)}>
        Approve
      </LoadingButton>
      {/* {USER_ROLES.AMCAPPROVER === role && ( */}
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={sendBack}
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleSendBack}
        disabled={reject || approve}>
        Send Back
      </LoadingButton>
      {/* )} */}
      {/* <Button
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleDialogOpen}>
        Approve
      </Button> */}
    </Grid>
  );
};

//Read only view for POA and Non Individual Application for AMC Approver,Individual Application for AMC Approver and POA Approver
const PoaOrNIApplicationDetails = ({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element => {
  const { status, editable, applicationType } = application || {};
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR", locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [openElogDialog, setOpenElogDialog] = useState<boolean>(false);
  const [duplicatePanApplicationCount, setDuplicatePanApplicationCount] = useState<number>(0);
  const [duplicatePanCheckboxValue, setDuplicatePanCheckboxValue] = useState<boolean>(false)


  const location = useLocation()
  const { path, url } = useRouteMatch();
  // console.log('location', location);

  const isEligibleForElog = (
    //Individual Investor
    (`${applicationType ?? ""}`.toLowerCase() === "individual")
  )

  const validateForm = async () => {
    const nationalitiesMdmsMasters = (await dispatch(
      getNationalityList()
    )) as unknown as nationaliyType;
    const documentsResponse = (await dispatch(getDocuments())) as unknown as Document;
    const responseRiskProfile = (await dispatch(
      riskProfileMasterData({
        riskProfileGroup: application?.riskProfileGroup ?? null,
        company: application?.company ?? null
      })
    )) as unknown as RiskProfileMaster;
    if (application?.applicationType?.toLowerCase() === "individual") {
      await isFormValidForSubmission(
        application as ApplicationProps,
        true,
        true,
        nationalitiesMdmsMasters,
        documentsResponse,
        role,
        responseRiskProfile.riskProfile,
        currencyCode,
        company
      );
    }
    if (application?.applicationType?.toLowerCase() === "non_individual") {
      const { applicants = [] } = application || {};
      const getInvestorType = applicants[0]?.investorType?.toString();

      if (getInvestorType && Object.keys(documentsResponse).includes(getInvestorType)) {
        await nonIndividualFormValidForSubmission(
          application,
          documentsResponse[getInvestorType] ?? [],
          nationalitiesMdmsMasters.countries,
          undefined,
          currencyCode,
          locale,
          true
        );
      }
    }
  };

  const handleOpen = () => setOpen(true);
  const handleDialogOpen = async () => {
    try {
      setApproveLoading(true);
      await validateForm();
      setApproveLoading(false);
      setOpenDialog(true);
    } catch (e) {
      setApproveLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const handleClose = () => {
    setOpen(false), setApproveLoading(false);
  };
  const handleDialogClose = () => {
    setOpenDialog(false), setRejectLoading(false);
  };

  const initialValues: Partial<ApplicationProps> = { rejectedReason: '' };
  const resonValidation = yup.object().shape({
    rejectedReason: yup.string().required('Please enter the reason for rejection'),
  });
  const onSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleClose();
      setRejectLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              rejectedReason: values.rejectedReason,
              status: 'rejected',
            },
            applicationId: application.id,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setRejectLoading(false);
    }
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              comment: values.comment,
              status: 'draft',
              applicationSentBack: true,
            },
            applicationId: application.id,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };

  return (
    USER_ROLES.AMCAPPROVER.includes(role)
      ?
      <CommonLayoutForPOA>
        <>
          <Box sx={{ px: { xs: 2, sm: 5 }, mt: { xs: 2, sm: 3 } }} ref={applicationDetailRef}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                justifyContent: 'space-between',
                // mt: 5,
              }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "15px"
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications-list"
                    disabled={approveLoading || rejectLoading}>
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography
                    variant='h2'
                    sx={(theme: Theme) => ({
                      // fontSize: 20,
                      // fontWeight: 600,
                      color: theme.palette.primary[500]
                    })}
                  >
                    Application Details
                  </Typography>
                </Box>
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({
                    marginLeft: "35px",
                    color: theme.palette.text.primary
                  })}
                >
                  {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor` :
                    ""
                  }
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end'
                }}
              >
                {editable && (
                  <IconButton>
                    <CardMedia
                      component="img"
                      src="/images/edit-icon-outlined.svg"
                      alt="Edit Icon"
                      sx={{ width: 'unset' }}
                      onClick={() =>
                        history.push(
                          role === USER_ROLES.POAAPPROVER
                            ? `/investment-details/edit-application`
                            : !checkIfApplicationIsNonIndividual(application) &&
                              USER_ROLES.AMCAPPROVER === role
                              ? `/application-checker-details/edit-application`
                              : `/non-individual-application-edit`,
                          {
                            id: application?.id,
                          }
                        )
                      }
                    />
                  </IconButton>

                )}
                {(application?.applicationNumber && path === "/application-details/:id") && <Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>}

              </Box>
            </Box>
            <IconButton
              sx={{
                position: 'fixed',
                right: 0,
                bottom: 75,
                borderRadius: '5px  0 0 5px',
                '&,:hover': {
                  bgcolor: 'primary.main',
                },
              }}
              onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
              <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
            </IconButton>
            {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
              <NonIndividualApplicationLayout
                loading={loading}
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}

              />
            ) : (
              <ApplicationDetailsCommonLayout
                loading={loading}
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}

              />
            )}
            {application &&
              ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                <RejectApproveButtons
                  handleOpen={handleOpen}
                  handleDialogOpen={handleDialogOpen}
                  approve={approveLoading}
                  reject={rejectLoading}
                  sendBack={sendBackLoading}
                  handleSendBack={handleSendBack}
                  duplicatePanApplicationCount={duplicatePanApplicationCount}
                  duplicatePanCheckboxValue={duplicatePanCheckboxValue}
                />
              ) : (
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      color: 'common.white',
                      minWidth: '200px',
                      mt: 4,
                      fontWeight: 600,
                      lineHeight: 1.5,
                    }}
                    onClick={() => {
                      history.push('/applications-list');
                    }}>
                    Done
                  </Button>
                </Box>
              ))}
            <Dialog
              onClose={handleClose}
              open={open}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box sx={{ mb: 2 }}>
                <CardMedia
                  component="img"
                  src="/images/warning-icon-red.svg"
                  sx={{ width: 'unset', mx: 'auto' }}
                />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Reject
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}>
                  {' '}
                  Give reason for application rejection *
                </Typography>
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                  validationSchema={resonValidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="rejectedReason"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={() => {
                            handleClose();
                          }}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
            <Dialog
              onClose={handleDialogClose}
              open={openDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: 'green' }}>
                    Approve
                  </Typography>{' '}
                  the application
                </Typography>
              </Box>
              <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleDialogClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  onClick={async () => {
                    try {
                      handleDialogClose();
                      setApproveLoading(true);

                      const getStatus = () => {
                        if (USER_ROLES.POAAPPROVER === role && application?.status === 'sent_to_poa_approver') {
                          return 'sent_to_amc_approver';
                        }

                        if (USER_ROLES.AMCAPPROVER === role && application?.status === 'sent_to_amc_approver') {
                          if (isEligibleForElog) {
                            return 'completed'
                          }

                          if (!application?.isEsignEnabled) {
                            return 'completed';
                          }

                          if (application?.hasPOA) {
                            return 'sent_to_authorised_signatories';
                          }

                          return (
                            sendApplication_Nri(application) ||
                            (
                              AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                              !checkIfApplicationIsNonIndividual(application)
                            )
                          )
                            ? 'sent_to_applicant1'
                            : 'sent_to_authorised_signatories';
                        }

                        return application?.status;
                      };

                      const response = await dispatch(
                        updateApplication({
                          body: {
                            ...application,
                            status: getStatus()
                          },
                          applicationId: application.id,
                        })
                      );

                      if (!response) {
                        return;
                      } else if (isEligibleForElog) {
                        setOpenElogDialog(true)
                      } else {
                        history.push('/applications-list');
                      }
                    } catch (e) {
                      dispatch(showError((e as Error)?.message ?? ""));
                      console.error((e as Error).message);
                    } finally {
                      setApproveLoading(false);
                    }
                  }}>
                  Continue
                </Button>
              </Grid>
            </Dialog>
            <Dialog
              onClose={handleSendBackClose}
              open={openSendBackDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'justify',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Send Back
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                <Formik
                  initialValues={initialCommentValues}
                  onSubmit={onSendBackSubmit}
                  validationSchema={Commentvalidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="comment"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={handleSendBackClose}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
            {/* Elog Dialog Start */}
            <Dialog
              onClose={() => setOpenElogDialog(false)}
              open={openElogDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton
                onClick={() => setOpenElogDialog(false)}
                sx={{ alignSelf: 'flex-end' }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                }}
              >
                <Typography
                  variant='h2'
                  sx={(theme: Theme) => ({
                    color: theme.palette.text.primary,
                    fontWeight: 500,
                    textAlign: 'center'
                  })}
                >
                  Application is submitted. Investor will get a E-log mail from BSE to Authenticate.
                </Typography>
              </Box>
              <Grid container sx={{ my: 3, justifyContent: 'center' }}>
                <Button
                  onClick={() => history.push('/applications-list')}
                  variant="outlined"
                  sx={(theme: Theme) => ({
                    ...theme.typography.body_400,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                  })}>
                  Okay
                </Button>
              </Grid>
            </Dialog>
            {/* Elog Dialog End */}
          </Box>
        </>
      </CommonLayoutForPOA >
      :
      (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}>
          <CommonLayoutForPOA>
            <>
              <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: { xs: 7, sm: 10 } }} ref={applicationDetailRef}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    justifyContent: 'space-between',
                    // mt: 5,
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "15px"
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications-list"
                        disabled={approveLoading || rejectLoading}>
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>
                      <Typography
                        variant='h2'
                        sx={(theme: Theme) => ({
                          // fontSize: 20,
                          // fontWeight: 600,
                          color: theme.palette.primary[500]
                        })}
                      >
                        Application Details
                      </Typography>
                    </Box>
                    <Typography
                      variant='body_600'
                      sx={(theme: Theme) => ({
                        marginLeft: "35px",
                        color: theme.palette.text.primary
                      })}
                    >
                      {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                        `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                        ""
                      } */}
                      {application?.onboardingType?.toLowerCase() === "minor" ?
                        `Minor Investor` :
                        ""
                      }
                      {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                        `Individual Investor ${application?.accountType ?
                          '(' + application?.accountType + ')' : ''}` :
                        ""
                      } */}
                      {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                        `Individual Investor` :
                        ""
                      }
                      {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                        `Non Individual Investor ${application?.accountType ?
                          '(' + application?.accountType + ')' : ''}` :
                        ""
                      } */}
                      {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                        `Non Individual Investor` :
                        ""
                      }
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}
                  >
                    {editable && (
                      <IconButton>
                        <CardMedia
                          component="img"
                          src="/images/edit-icon-outlined.svg"
                          alt="Edit Icon"
                          sx={{ width: 'unset' }}
                          onClick={() =>
                            history.push(
                              role === USER_ROLES.POAAPPROVER
                                ? `/investment-details/edit-application`
                                : !checkIfApplicationIsNonIndividual(application) &&
                                  USER_ROLES.AMCAPPROVER === role
                                  ? `/investment-details/edit-application`
                                  : `/non-individual-application-edit`,
                              {
                                id: application?.id,
                              }
                            )
                          }
                        />
                      </IconButton>

                    )}
                    {(application?.applicationNumber && path === "/application-details/:id") && <Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>}

                  </Box>
                </Box>
                <IconButton
                  sx={{
                    position: 'fixed',
                    right: 0,
                    bottom: 75,
                    borderRadius: '5px  0 0 5px',
                    '&,:hover': {
                      bgcolor: 'primary.main',
                    },
                  }}
                  onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
                  <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
                </IconButton>
                {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
                  <NonIndividualApplicationLayout loading={loading} application={application} />
                ) : (
                  <ApplicationDetailsCommonLayout loading={loading} application={application} />
                )}
                {application &&
                  ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                    (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                    <RejectApproveButtons
                      handleOpen={handleOpen}
                      handleDialogOpen={handleDialogOpen}
                      approve={approveLoading}
                      reject={rejectLoading}
                      sendBack={sendBackLoading}
                      handleSendBack={handleSendBack}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          color: 'common.white',
                          minWidth: '200px',
                          mt: 4,
                          fontWeight: 600,
                          lineHeight: 1.5,
                        }}
                        onClick={() => {
                          history.push('/applications-list');
                        }}>
                        Done
                      </Button>
                    </Box>
                  ))}
                <Dialog
                  onClose={handleClose}
                  open={open}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box sx={{ mb: 2 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset', mx: 'auto' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Reject
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}>
                      {' '}
                      Give reason for application rejection *
                    </Typography>
                    <Formik
                      initialValues={initialValues}
                      onSubmit={onSubmit}
                      validationSchema={resonValidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="rejectedReason"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={() => {
                                handleClose();
                              }}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
                <Dialog
                  onClose={handleDialogClose}
                  open={openDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 20,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: 'green' }}>
                        Approve
                      </Typography>{' '}
                      the application
                    </Typography>
                  </Box>
                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Button
                      onClick={() => {
                        handleDialogClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      onClick={async () => {
                        try {
                          handleDialogClose();
                          setApproveLoading(true);
                          await dispatch(
                            updateApplication({
                              body: {
                                ...application,
                                status:
                                  USER_ROLES.POAAPPROVER === role &&
                                    application?.status === 'sent_to_poa_approver'
                                    ? 'sent_to_amc_approver'
                                    : USER_ROLES.AMCAPPROVER === role &&
                                      application?.status === 'sent_to_amc_approver'
                                      ? !application?.isEsignEnabled
                                        ? 'completed'
                                        : application?.hasPOA
                                          ? 'sent_to_authorised_signatories'
                                          : sendApplication_Nri(application) ||
                                            (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                              !checkIfApplicationIsNonIndividual(application))
                                            ? 'sent_to_applicant1'
                                            : 'sent_to_authorised_signatories'
                                      : application?.status,
                              },
                              applicationId: application.id,
                            })
                          );
                          history.push('/applications-list');
                        } catch (e) {
                          console.error((e as Error).message);
                        } finally {
                          setApproveLoading(false);
                        }
                      }}>
                      Continue
                    </Button>
                  </Grid>
                </Dialog>
                <Dialog
                  onClose={handleSendBackClose}
                  open={openSendBackDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'justify',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Send Back
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                    <Formik
                      initialValues={initialCommentValues}
                      onSubmit={onSendBackSubmit}
                      validationSchema={Commentvalidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="comment"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={handleSendBackClose}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
              </Box>
              <Footer />
            </>
          </CommonLayoutForPOA >
        </Box >
      )
  );
};

export default function ApplicationDetails(): JSX.Element {
  const theme = useTheme();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const [openDiyInvCheckerDialog, setDiyInvCheckerDialog] = useState<boolean>(false);
  const [isCurrentStatusNotDraft, setCurrentStatusNotDraft] = useState<boolean>(false)
  const [investorDeclaration, setInvestorDeclaration] = useState({
    isDeclareTermsAndConditions: false,
  });
  const [leegalityUrlOpen, setLeegalityUrlOpen] = useState(false);
  const [eLogUrlOpen, setElogUrlOpen] = useState<boolean>(false)
  const [openElogDialog, setOpenElogDialog] = useState<boolean>(false);
  const [eLogUrl, setELogUrl] = useState<string>("");

  const { path, url } = useRouteMatch();

  const isDiyInvOnboardingApplicationDetails = path.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = path.includes('investor-onboarding-application-preview')
  const isApplicationPreview = path.includes('application-preview');

  const routerUrl = url.substring(0, url.lastIndexOf('/'))

  //new 
  const { application: applicationDetail } = useSelector((store: RootStateType) => store.application);
  const { currentStep } = applicationDetail || {};

  const isEligibleForElog = (
    //Individual Investor
    (`${application?.applicationType ?? ""}`.toLowerCase() === "individual")
  )

  // Checker flow is skipped for individual investors when onboarded by RM. For Non-Individual, Minor and NRI investors, checker flow is NOT skipped

  const isCheckerFlowSkipped = (
    // checking for normal and minor
    `${application?.onboardingType ?? ""}`?.toLowerCase() === "normal" &&
    // checking for individual and non-individual
    `${application?.applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL &&
    // checking for NRI and Resident investors
    applicantStatusMasters[application?.applicants?.[0]?.status ?? ""] === applicantStatusMasters.Individual &&
    // checking for RM and DIY flow, but excluding physical journey
    ["/application-preview/:id"].includes(path) && application?.onboardingVia !== 'physical'
  )

  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        setApplication(_application);
        setCurrentStatusNotDraft(_application?.status?.toLowerCase() !== 'draft')
        setInvestorDeclaration({
          ...investorDeclaration,
          isDeclareTermsAndConditions: _application?.isDeclareTermsAndConditions || false,
        });
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  const { editable, hasPOA, applicationSentBack = false } = application || {};
  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);

  const menuList =
    application &&
    (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? NonIndividualMenuItemList
      : MenuItemList);

  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = application || {};
      if (id) {
        const response = (await dispatch(
          updateApplication({
            body: {
              ...application,
              status:
                isDiyInvOnboardingApplicationPreview
                  ? 'sent_to_amc_approver'
                  : hasPOA
                    ? 'sent_to_poa_approver'
                    : sendApplication_Nri(application) ||
                      (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                      ? 'sent_to_amc_approver'
                      : !AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
                        ? 'sent_to_applicant1'
                        : status,
              comment: values.comment,
              applicationSentBack: false,
            },
            applicationId: id,
          })
        )) as unknown as ApplicationProps;

        if (!response) return

        setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft')

        if (isDiyInvOnboardingApplicationPreview) {
          setDiyInvCheckerDialog(true)
          return
        }

        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      const { id, status } = application || {};
      setIsSubmitting(true);
      if (id) {

        const response = (await dispatch(
          updateApplication({
            body: {
              ...application,
              status:
                isCheckerFlowSkipped
                  ? "completed"
                  : isDiyInvOnboardingApplicationPreview
                    ? "sent_to_amc_approver"
                    : hasPOA
                      ? 'sent_to_poa_approver'
                      : // : (status === 'draft' || status === 'sent_to_amc_approver') &&
                      (sendApplication_Nri(application) ||
                        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)))
                        ? 'sent_to_amc_approver'
                        : (!AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                          ? 'sent_to_applicant1'
                          : status,
              applicationSentBack: isCheckerFlowSkipped ? false : application?.applicationSentBack,
            },
            applicationId: id,
          })
        )) as unknown as ApplicationProps;

        if (!response) {
          return
        } else if (isCheckerFlowSkipped) {
          setOpenElogDialog(true)
        } else {
          setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft')
          if (isDiyInvOnboardingApplicationPreview) {
            setDiyInvCheckerDialog(true)
            return
          }
          history.push('/applications');
        }
      }
    } catch (e) {
      dispatch(showError((e as Error)?.message ?? ""));
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleESignElogBtn = async (values: {
    isDeclareTermsAndConditions: boolean;
  }) => {
    try {
      setIsSubmitting(true);

      let applicationResponse = application

      if (id && values.isDeclareTermsAndConditions && !applicationResponse?.isDeclareTermsAndConditions) {
        applicationResponse = (await dispatch(sendIsDeclareTermsAndConditions(applicationResponse?.id ?? ""))) as unknown as ApplicationProps;

        setApplication(applicationResponse ?? {})
      }

      //in case of ELOG
      if (isEligibleForElog) {
        const { id } = applicationResponse || {};

        if (id) {
          const response = (await dispatch(
            updateApplication({
              body: {
                ...applicationResponse,
                status: 'completed',

              },
              applicationId: id,
            })
          )) as unknown as ApplicationProps;

          if (!response) return

          await dispatch(storeInvestorClientId({ investorClientId: response?.clientCode ?? "" }))
          await dispatch(storeInterfaceCode(response?.clientInterfaceCode ?? ""))
          await dispatch(storeIwappId({ iwappRmId: response?.rm?.iwappRmId ?? "" }))
          await dispatch(setInvestorRmId(response?.rm?.iwappRmId ?? ""))
          await dispatch(storeApplicationId({ applicationId: response?.id ?? "" }))

          await dispatch(setDiyInvestorOnboardingAuthData({
            diyInvOnboardingPrev: false,
            diyInvestorOnboarding: false,
            diyInvestorOnboardingEdit: false,
            id: response?.applicants?.[0]?.id ?? ""
          }))


          if (response?.elog_url_1 && response?.elog_url_1.length > 0) {

            // await dispatch(setDiyInvestorOnboardingAuthData({
            //   diyInvOnboardingPrev: false,
            //   diyInvestorOnboarding: false,
            //   diyInvestorOnboardingEdit: false,
            //   id: application?.applicants?.[0]?.id ?? ""
            // }))
            setELogUrl(response?.elog_url_1);
            setElogUrlOpen(true)
            setOpenElogDialog(true)
          }
        }
      }
      // in case of ESign
      else {
        const response = await (dispatch(diyESign({
          applicationId: Number(applicationResponse?.id ?? "")
        })) as unknown as Promise<DiyESignResponseBody>)

        if (response?.url) {
          setLeegalityUrlOpen(true);
          dispatch(showError(`${leegalityText}`));
          window.open(response?.url, '_blank');
          return;
        }
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleInvestorDashboardBtn = async () => {

    if (isCheckerFlowSkipped) {
      history.push('/applications');
      return
    }

    // await dispatch(storeInvestorClientId({ investorClientId: application?.clientCode ?? "" }))
    // await dispatch(storeInterfaceCode(application?.clientInterfaceCode ?? ""))
    // await dispatch(storeIwappId({ iwappRmId: application?.rm?.iwappRmId ?? "" }))
    // await dispatch(setInvestorRmId(application?.rm?.iwappRmId ?? ""))
    // await dispatch(storeApplicationId({ applicationId: application?.id ?? "" }))

    // await dispatch(setDiyInvestorOnboardingAuthData({
    //   diyInvOnboardingPrev: false,
    //   diyInvestorOnboarding: false,
    //   diyInvestorOnboardingEdit: false,
    //   id: application?.applicants?.[0]?.id ?? ""
    // }))

    // history.push('/investor-dashboard')
    if (eLogUrl)
      window.open(eLogUrl, '_self');
    else
      history.push('/investor-dashboard')
  }

  const LayoutComponent = (isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? InvOnboardingLayout : CommonLayout;

  return [
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.RM,
    USER_ROLES.OPE,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.INVESTOR
  ].includes(role) ? (
    <LayoutComponent>
      <>
        <Box component={'div'} style={{ marginBottom: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) ? (
            <Typography variant='h1' sx={{ color: 'text.primary' }}>
              {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {application?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding` :
                ""
              }
              {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding ${application?.accountType ?
                  '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding` :
                ""
              }
              {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding ${application?.accountType ?
                  '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding` :
                ""
              }
            </Typography >
          ) : (
            [USER_ROLES.AMC_ADMIN].includes(role) ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "20px"
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications"
                  // disabled={approveLoading || rejectLoading}
                  >
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                </Box>
                <Typography variant='h2' sx={{ color: 'text.primary', marginLeft: "35px" }}>
                  {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor` :
                    ""
                  }
                </Typography>
              </Box>
            ) : (
              <Box>
                <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                <Typography variant='h2' sx={{ color: 'text.primary', marginTop: "20px" }}>
                  {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor Onboarding ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor Onboarding` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor Onboarding ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor Onboarding` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor Onboarding ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor Onboarding` :
                    ""
                  }
                </Typography>
              </Box>
            )
            // <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
          )}
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) && <Typography sx={{ fontWeight: '500', fontSize: 16, letterSpacing: '0.02px', color: 'text.primary' }}>{`Application ID: ${application?.applicationNumber}`}</Typography>}
        </Box>
        <Grid container sx={(theme: Theme) => ({
          p: {xs:"10px",sm:"35px"},
          border: `1px solid ${theme.palette.text.secondary}26`,
          borderRadius: "15px",
          background: theme.palette.background.paper,
          position: 'relative'
        })}>
          <Hidden lgDown={true}>
            <Grid item xs={12} lg={3} sx={{ padding: 0, position: 'sticky', top: '18px' }}>
              <Stack sx={{ position: 'sticky', top: '18px', pl: 4, py: 3, display: { lg: 'block', xl: 'block' } }}>
                {/* Stepper */}
                <Stepper
                  activeStep={currentStep ?? 0}
                  orientation="vertical"
                  connector={<BootstrapStepConnector />}
                  sx={{
                    "&.MuiStepper-vertical": {
                      ".MuiStepButton-vertical": {
                        ".MuiStepLabel-vertical": {
                          paddingTop: "0px",
                          paddingBottom: "0px"
                        }
                      }
                    }
                  }}
                >
                  {menuList &&
                    menuList.map((item, index) => {
                      const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;

                      return <Step key={index}>
                        <StepButton
                          href={
                            isDiyInvOnboardingApplicationPreview
                              ? `#${MenuItemListLink[index]}`
                              : isDiyInvOnboardingApplicationDetails
                                ? `#${MenuItemListLink[index]}`
                                : routerUrl === '/application-details' ? !isItemDisabled && application && application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? `#${NonIndividualMenuItemListLink[index]}` : `#${MenuItemListLink[index]}` : ''
                          }
                          onClick={() =>
                            isDiyInvOnboardingApplicationDetails
                              ? null
                              : isDiyInvOnboardingApplicationPreview
                                ? null
                                : routerUrl !== '/application-details' ? !isItemDisabled &&
                                  history.replace(
                                    `${application &&
                                    (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                                      ? `/application/${NonIndividualMenuItemListLink[index]}`
                                      : `/application/${MenuItemListLink[index]}`)
                                    }`,
                                    {
                                      id: application.id,
                                      applicant1ReferenceId: application.applicant1ReferenceId,
                                    }
                                  ) : null
                          }
                        >
                          <StepLabel
                            sx={(theme: Theme) => ({
                              "& .MuiStepLabel-label.Mui-completed": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-label.Mui-active": {
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500]
                              },
                              "& .MuiStepLabel-label.Mui-disabled": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-iconContainer.Mui-active": {
                                "& .MuiStepIcon-root.Mui-active": {
                                  color: theme.palette.primary[500]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.textDark.primary
                                }
                              },
                              "& .MuiStepLabel-iconContainer.Mui-disabled": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.grey[100]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.text.secondary
                                }
                              }
                            })}
                            StepIconComponent={({ completed, ...props }: StepIconProps) => (
                              <StepIcon {...props} icon={completed ? <StepperSuccessIcon /> : props.icon} />
                            )}
                          >
                            {item}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    })}
                </Stepper>

              </Stack>
            </Grid>
          </Hidden>
          <Grid item
            container
            md={12}
            lg={9}
            sx={(theme: Theme) => ({
            })}
          >
            <Box
              component="div"
              sx={(theme: Theme) => ({
                padding: { xs: "10px", sm: "35px" },
                border: `1px solid ${theme.palette.text.secondary}26`,
                borderRadius: "15px",
                backgroundColor: theme.palette.common.white,
                width: "100%",
              })}
            >
              <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5 }}
                ref={applicationDetailRef}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  {path === "/investor-onboarding-application-preview/:id" ? (
                    <>
                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : path === "/application-preview/:id" ? (
                    <>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications">
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>

                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: { xs: 1, sm: 0 },
                        }}
                      >
                        {/* Left side (App ID + Status) */}
                        <Box>
                          <Typography
                            component={"div"}
                            variant="h2"
                            sx={{ color: "text.primary", letterSpacing: "0.01px", mb: 1 }}
                          >
                            <Typography
                              variant="h2"
                              sx={{
                                color: "text.primary",
                                letterSpacing: "0.01px",
                                display: "inline",
                              }}
                            >
                              Application ID:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={{
                                fontWeight: "400",
                                fontSize: 20,
                                display: "inline",
                                color: "text.primary",
                              }}
                            >
                              {application?.applicationNumber}
                            </Typography>
                          </Typography>

                          <Typography
                            component={"div"}
                            variant="h2"
                            sx={{ color: "text.primary", letterSpacing: "0.01px", mb: 1 }}
                          >
                            <Typography
                              variant="h2"
                              sx={{
                                color: "text.primary",
                                letterSpacing: "0.01px",
                                display: "inline",
                              }}
                            >
                              Status:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={(theme: Theme) => ({
                                fontWeight: "400",
                                fontSize: 20,
                                display: "inline",
                                color:
                                  application?.status === "draft"
                                    ? theme.palette.primary[500]
                                    : theme.palette.warning[500],
                                textTransform: "capitalize",
                              })}
                            >
                              {`${APPLICATION_LISTING_STATUS[application?.status ?? '']} ${application?.applicationSentBack ? '(Sent Back)' : ''}`}
                            </Typography>
                          </Typography>
                        </Box>

                        {/* Right side (Client Code) */}
                        {application?.clientCode && (
                          <Box>
                            <Typography
                              component={"div"}
                              variant="h2"
                              sx={{ color: "text.primary", letterSpacing: "0.01px", mb: 1 }}
                            >
                              <Typography
                                variant="h2"
                                sx={{
                                  color: "text.primary",
                                  letterSpacing: "0.01px",
                                  display: "inline",
                                }}
                              >
                                Client Code:{' '}
                              </Typography>
                              <Typography
                                variant="inherit"
                                sx={{
                                  fontWeight: '400',
                                  fontSize: 20,
                                  display: "inline",
                                  color: "text.primary",
                                }}
                              >
                                {application?.clientCode}
                              </Typography>
                            </Typography>
                          </Box>
                        )}
                      </Box>


                    </>
                  )
                  }

                  {/* <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications">
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                    Summary
                  </Typography> */}
                </Box>
                {(![USER_ROLES.AMC_ADMIN].includes(role) && (!isDiyInvOnboardingApplicationPreview) && (!isApplicationPreview) &&
                  ((isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview)
                    ? !isCurrentStatusNotDraft
                    : editable
                  )
                ) && (
                    // <IconButton>
                    //   <CardMedia
                    //     component="img"
                    //     src="/images/edit-icon-outlined.svg"
                    //     alt="Edit Icon"
                    //     sx={{ width: 'unset' }}
                    //     onClick={() => history.push(`/application`, { id })}
                    //   />
                    // </IconButton>
                    <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      sx={(theme: Theme) => ({
                        padding: '15px',
                        border: `0.5px solid ${theme.palette.text.secondary}`,
                        borderRadius: '10px',
                        color: theme.palette.text.secondary,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: '18px',
                        fontWeight: 700,
                        cursor: 'pointer',

                      })}
                      onClick={() => history.push(`${(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? "/investor-onboarding-application/rm-details" : "/application"}`, { id })}
                    >
                      Edit
                    </Button>
                  )}
              </Box>
              {!isDiyInvOnboardingApplicationPreview && (
                <>
                  <ApplicationDetailsCommonLayout
                    loading={loading}
                    application={application as ApplicationProps}
                  />
                  {["/application-preview/:id"].includes(path) && editable && (
                    <Grid container spacing={2} sx={{ mt: 4 }} >
                      <Grid item xs={12} md={6}>
                        <Button
                          variant="outlined"
                          startIcon={<EditIcon />}
                          sx={(theme: Theme) => ({
                            padding: '15px',
                            border: `0.5px solid ${theme.palette.text.secondary}`,
                            borderRadius: '10px',
                            color: theme.palette.text.secondary,
                            fontFamily: theme.typography.fontFamily,
                            fontSize: '18px',
                            fontWeight: 700,
                            cursor: 'pointer',
                            width: '100%',
                            // minWidth: "457px",
                            // mt: 4,

                          })}
                          disabled={(isSubmitting || sendBackLoading)}
                          onClick={() => history.push(`${(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? "/investor-onboarding-application/rm-details" : "/application"}`, { id })}
                        >
                          Edit
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Button
                          variant="contained"
                          sx={(theme: Theme) => ({
                            color: 'common.white',
                            width: '100%',
                            // minWidth: '200px',
                            // minWidth: "457px",
                            // mt: 4,
                            // fontWeight: 600,
                            // lineHeight: 1.5,
                            // fontSize: '16px',
                            ...theme.typography.body_700
                          })}
                          onClick={async () => {
                            isCheckerFlowSkipped ?
                              setDialog(true) :
                              ((sendApplication_Nri(application) ||
                                (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))) &&
                                applicationSentBack)
                                ? handleSendBack()
                                : setDialog(true);
                          }}
                          disabled={(isSubmitting || sendBackLoading)}
                        >
                          {`${application?.hasPOA
                            ? 'Send to POA Approver'
                            : (sendApplication_Nri(application) ||
                              (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)))
                              ? isCheckerFlowSkipped ?
                                'Submit' :
                                'Send to Checker'
                              : 'Send to Investor'
                            } 
                          ${isSubmitting || sendBackLoading ? '...' : ''}`}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
              {isDiyInvOnboardingApplicationPreview && (
                <Formik
                  initialValues={investorDeclaration}
                  validate={(values: {
                    isDeclareTermsAndConditions: boolean;
                  }) => {
                    try {
                      validateYupSchema(values, DeclareTermsAndConditionsScheme, true, values);
                    } catch (e) {
                      return yupToFormErrors(e);
                    }
                  }}
                  onSubmit={handleESignElogBtn}
                  enableReinitialize={true}
                >
                  {({ values, setValues }) => (
                    <Form>
                      <ApplicationDetailsCommonLayout
                        loading={loading}
                        application={application as ApplicationProps}
                        values={values}
                        setValues={setValues}
                        leegalityUrlOpen={leegalityUrlOpen}
                        eLogUrlOpen={eLogUrlOpen}
                      />
                      {["/investor-onboarding-application-preview/:id"].includes(path) && editable && (
                        <Grid container spacing={2} sx={{ mt: 4 }} >
                          <Grid item xs={12} md={6}>
                            <Button
                              variant="outlined"
                              startIcon={<EditIcon />}
                              sx={(theme: Theme) => ({
                                padding: '15px',
                                border: `0.5px solid ${theme.palette.text.secondary}`,
                                borderRadius: '10px',
                                color: theme.palette.text.secondary,
                                fontFamily: theme.typography.fontFamily,
                                fontSize: '18px',
                                fontWeight: 700,
                                cursor: 'pointer',
                                width: '100%',
                                // minWidth: "457px",
                                // mt: 4,

                              })}
                              disabled={
                                isSubmitting || sendBackLoading}
                              onClick={() => history.push(`${(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? "/investor-onboarding-application/rm-details" : "/application"}`, { id })}
                            >
                              Edit
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Button
                              variant="contained"
                              type="submit"
                              sx={(theme: Theme) => ({
                                color: 'common.white',
                                width: '100%',
                                // minWidth: '200px',
                                // minWidth: "457px",
                                // mt: 4,
                                // fontWeight: 600,
                                // lineHeight: 1.5,
                                // fontSize: '16px',
                                ...theme.typography.body_700
                              })}
                              disabled={
                                isSubmitting ||
                                sendBackLoading ||
                                leegalityUrlOpen ||
                                eLogUrlOpen ||
                                (isDiyInvOnboardingApplicationPreview
                                  ? isCurrentStatusNotDraft
                                  : false
                                )}
                            >
                              {`${isEligibleForElog ? 'Submit' : 'E-Sign'} ${isSubmitting || sendBackLoading ? '...' : ''}`}
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </Form>
                  )}
                </Formik>
              )}
            </Box>
          </Grid>
        </Grid>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        <Dialog
          onClose={handleSendBackClose}
          open={openSendBackDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'justify',
              },
            }}>
            <Typography
              sx={{ color: 'primary.main', mt: 2 }}>{`Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
                ? "Checker"
                : application?.hasPOA
                  ? 'POA Approver'
                  : sendApplication_Nri(application) ||
                    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                    ? 'Checker'
                    : 'Investor'
                } ?`}</Typography>
            <Typography sx={{ color: 'primary.main', mt: 2 }}>Provide comments *</Typography>
            <Formik
              initialValues={initialCommentValues}
              onSubmit={onSendBackSubmit}
              validationSchema={Commentvalidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="comment"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <LoadingButton
                      loading={sendBackLoading}
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      type="submit">
                      Yes
                    </LoadingButton>
                    <Button
                      onClick={() => {
                        handleSendBackClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}
                      disabled={sendBackLoading}>
                      No
                    </Button>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <ConfirmationDialog
          message={
            isCheckerFlowSkipped ?
              "Are you sure you want to submit the application"
              : `Sending details to ${isDiyInvOnboardingApplicationPreview
                ? 'Checker'
                : application?.hasPOA
                  ? 'POA Approver'
                  : (sendApplication_Nri(application) ||
                    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)))
                    ? 'Checker'
                    : 'Investor'
              }`
          }
          subMessage={
            isCheckerFlowSkipped ?
              ""
              : `Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
                ? 'Checker'
                : application?.hasPOA
                  ? 'POA Approver'
                  : sendApplication_Nri(application) ||
                    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                    ? 'Checker'
                    : 'Investor'
              } ?`}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        />
        {/* DIY Investor Onboarding Checker Success Dialog Start */}
        <Dialog
          aria-labelledby="success-dialog"
          open={openDiyInvCheckerDialog}
          PaperProps={{
            sx: (theme: Theme) => ({
              maxWidth: '550px',
              width: "100%",
              borderRadius: "12px",
              padding: "24px",
              backgroundColor: theme.palette.common.white
            }),
          }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              rowGap: "12px",
              padding: "15px",
              overflow: "hidden"
            }}
          >
            <SuccessIcon />
            <Typography
              variant="h2"
              sx={(theme: Theme) => ({
                lineHeight: "25px",
                letterSpacing: "0.01px",
                color: theme.palette.text.primary
              })}
            >
              Success
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              Details successfully send to Checker
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              padding: "0px",
              marginTop: "40px",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={() => setDiyInvCheckerDialog(false)}
              sx={(theme: Theme) => ({
                ...theme.typography.body_500,
                fontWeight: 600,
                lineHeight: "20px",
                color: theme.palette.common.white,
                borderRadius: "4px",
                padding: "13px 20px",
                backgroundColor: theme.palette.primary[500]
              })}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        {/* DIY Investor Onboarding Checker Success Dialog End */}
        {/* Elog Dialog Start */}
        <Dialog
          open={openElogDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '80%' },
            },
          }}>
          <Box
            sx={{
              width: { xs: '100%', sm: '90%' },
              mx: 'auto',
            }}
          >
            <Typography
              variant={isCheckerFlowSkipped ? 'h2' : 'body_500'}
              sx={(theme: Theme) => ({
                color: theme.palette.text.primary,
                fontWeight: 500,
                textAlign: 'center'
              })}
            >
              {/* Application is submitted. You will get a E-log mail from BSE to Authenticate. */}
              {isCheckerFlowSkipped ? "Application is submitted. Investor will get a E-log mail from BSE to Authenticate." : ELOG_BSE}
            </Typography>
          </Box>
          <Grid container sx={{ mt: 3, justifyContent: 'center' }}>
            <Button
              onClick={handleInvestorDashboardBtn}
              variant="outlined"
              sx={(theme: Theme) => ({
                ...theme.typography.subtitle_600,
                color: 'primary.main',
                minWidth: 180,
                letterSpacing: 2,
              })}>
              {isCheckerFlowSkipped ? "Okay" : "Redirect To BSE"}
            </Button>
          </Grid>
        </Dialog>
        {/* Elog Dialog End */}
      </>
    </LayoutComponent>
  ) : (
    <PoaOrNIApplicationDetails loading={loading} application={application as ApplicationProps} />
  );
}
